import { render } from "./report2.vue?vue&type=template&id=7f6c35ea"
import script from "./report2.vue?vue&type=script&lang=js"
export * from "./report2.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__